import { Capacitor } from '@capacitor/core';
import { useTranslation } from 'react-i18next';

// Адрес магазина — общий с плашкой «Вышла новая версия» (почему ссылка, а не окно браузера, — там же).
import { STORE_URL } from '@/lib/storeLinks';

/**
 * «Обновите приложение» — единственный экран, который намеренно НЕ пускает
 * дальше.
 *
 * ⚠️ ЗАЧЕМ ОН НУЖЕН. 01.09.2026 приложение начало слать заголовок, которого
 * сервер не разрешал, и обновившиеся остались без входа. Чинилось это на
 * сервере — но если однажды сломается наоборот, и старое приложение перестанет
 * понимать сервер, единственным выходом будет попросить обновиться. Без такого
 * экрана человек видел бы бесконечные ошибки и не знал, что делать.
 *
 * ⚠️ ТОЛЬКО ВНУТРИ ПРИЛОЖЕНИЯ. На сайте обновлять нечего: там всегда свежая
 * страница.
 */
export function UpdateRequiredScreen() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-surface px-8 text-center">
      <span className="material-symbols-outlined text-5xl text-primary">download</span>
      <h1 className="font-display text-2xl font-bold text-on-surface">{t('updateRequired.title')}</h1>
      <p className="max-w-sm text-sm text-on-surface-variant">{t('updateRequired.text')}</p>
      <a
        href={Capacitor.getPlatform() === 'android' ? STORE_URL.android : STORE_URL.ios}
        className="mt-2 rounded-button bg-primary px-6 py-3 text-sm font-semibold text-on-primary"
      >
        {t('updateRequired.cta')}
      </a>
    </div>
  );
}
